export const en = {
    'empty-header': 'No base queries',
    'empty-text': 'Add base queries',
    'error-header': 'Unable to load keywords'
};
